import { moneyFormat } from "./BRLFormat";

const BRAZIL_COUNTRY_CODE = "BR";
const USD_CURRENCY_CODE = "USD";
const BRAZIL_USD_ADVANCE_MINIMUM_AMOUNT = 500;
const DEFAULT_ADVANCE_MINIMUM_AMOUNT = 1000;

interface AdvanceCurrencyContext {
  country?: string | null;
  currency?: string | null;
}

export const getAdvanceMinimumAmount = ({
  country,
  currency,
}: AdvanceCurrencyContext): number => {
  const isBrazilAdvanceInUsd =
    country?.toUpperCase() === BRAZIL_COUNTRY_CODE &&
    currency?.toUpperCase() === USD_CURRENCY_CODE;

  return isBrazilAdvanceInUsd
    ? BRAZIL_USD_ADVANCE_MINIMUM_AMOUNT
    : DEFAULT_ADVANCE_MINIMUM_AMOUNT;
};

export const formatAdvanceMinimumAmount = (
  context: AdvanceCurrencyContext,
): string => {
  return moneyFormat(
    getAdvanceMinimumAmount(context),
    context.currency || USD_CURRENCY_CODE,
  );
};
